import { jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
export default function Copyright() {
    const year = new Date().getFullYear();
    const output = (_jsxs(Typography, Object.assign({ variant: "body2", color: "violet.main" }, { children: ["Copyright (c) ", year, " Andrew Paris LLC. All Rights Reserved."] })));
    return output;
}
